export default __webpack_public_path__ + "static/media/integer.5d029e0d.svg";